import Pill from "components/Pill/PillElement";
import React from "react";

export interface DocumentLifeCyclePillProps {
  value: server.dto.DocumentLifeCycles
  isInvoice?: boolean;
  overDue?: boolean
};

const DocumentLifeCyclePill = (props: DocumentLifeCyclePillProps) => {
  const { value, overDue } = props;

  const labels: { [key in server.dto.DocumentLifeCycles]: string } = {
    unknown: RESX.GeneralLabels.Unknown,
    draft: RESX.DocumentLifeCycle.Draft,
    review: RESX.DocumentLifeCycle.Review,
    pending: props.isInvoice ? RESX.Financial.Outstanding : RESX.DocumentLifeCycle.OutForSignature,
    completed: props.isInvoice ? RESX.Financial.Settled : RESX.DocumentLifeCycle.Completed,
    discarded: RESX.DocumentLifeCycle.Discarded
  };

  switch (value) {
    case "draft":
      return <Pill color="darkgray" label={labels.draft} />;
    case "review":
      return <Pill color="purple" label={labels.review} />;
    case "pending":
      return overDue
        ? <Pill color="pink" label={labels.pending} />
        : <Pill color="orange" label={labels.pending} />;
    case "completed":
      return <Pill color="green" label={labels.completed} />;
    case "discarded":
      return <Pill color="gray" label={labels.discarded} />;
    default:
      console.error(`value ${value} is not implemented in DocumentLifeCycleLabel`);
  }
};

export default DocumentLifeCyclePill;